import type { AssetDto } from 'src/store/generated/leela-api-generated';

/**
 * Identity key for a single asset row: `${assetId}::${productStrategyId}`.
 * Rows with no productStrategyId key to `assetId::`.
 */
export function assetStrategyKey (
  asset: Pick<AssetDto, 'assetId' | 'productStrategyId'>,
): string {
  return `${asset.assetId}::${asset.productStrategyId ?? ''}`;
}

/** True when two asset rows are the same (assetId, productStrategyId) pair. */
export function isSameAssetStrategy (
  a: Pick<AssetDto, 'assetId' | 'productStrategyId'>,
  b: Pick<AssetDto, 'assetId' | 'productStrategyId'>,
): boolean {
  return a.assetId === b.assetId && (a.productStrategyId ?? '') === (b.productStrategyId ?? '');
}
